// extracted by mini-css-extract-plugin
export default {"depositButton":"CurrencyAmountChip_depositButton__yYDPn"};